const InteractionEventName = {};
export default InteractionEventName;

InteractionEventName.LEVEL_STARTED = "level_started";
InteractionEventName.SPOT_SELECTED = "spot_selected";
InteractionEventName.SPOT_DESELECTED = "spot_deselected";
InteractionEventName.LEVEL_SUBMITTED = "level_submitted";
InteractionEventName.DISABLE_VIEW = "disable_view";
InteractionEventName.ENABLE_VIEW = "enable_view";